<div
  class="bn-content-slider"
  [ngClass]="{
    'text-center': centered,
  }"
  [style.width]="width"
  (mouseenter)="onMouseOver()"
  (mouseleave)="onMouseLeave()">
  @if (loading) {
    <bn-web-ui-loading
      [isTransparent]="true"
      [showSpinner]="true" />
  } @else {
    <div
      class="bn-content-slider__content"
      [style.left]="-activeIndex * 100 + '%'"
      [style.width]="'calc(' + (items?.length || 0) + '*' + (width || '100%') + ')'">
      @for (item of items; track item; let index = $index) {
        <div
          class="bn-content-slider__content__item"
          [style.width]="100 / (items?.length || 0) + '%'">
          <img
            class="bn-content-slider__content__item__image"
            [alt]="item.image.alt"
            [ngClass]="{
              'bn-content-slider__content__item__image--clickable': item.image.routerLink,
            }"
            [routerLink]="item.image.routerLink"
            [src]="item.image.src"
            [title]="item.image.title ?? ''" />
          <div
            class="bn-content-slider__content__item__title"
            [innerHtml]="item.title"></div>
          <div
            class="bn-content-slider__content__item__description"
            [innerHtml]="item.description"></div>
          @if (item.button) {
            <a
              bn-web-ui-button
              class="d-inline-block mt-4"
              data-e2e="AuthPagesContentSliderItemButton"
              itemStyle="outline"
              size="xl"
              target="_blank"
              [href]="item.button.href"
              >{{ item.button.text }}</a
            >
          }
        </div>
      }
    </div>
    @if ((items?.length || 0) > 1) {
      <div class="bn-content-slider__pagination">
        @for (item of items; track item; let index = $index) {
          <div
            class="bn-content-slider__pagination__item"
            data-e2e="AuthPagesContentSliderPaginationItem"
            [ngClass]="{
              'bn-content-slider__pagination__item--selected': activeIndex === index,
            }"
            (click)="onPaginationClick(index)"></div>
        }
      </div>
    }
  }
</div>
